import { generateId } from '@freelancer/datastore/testing/helpers';
import type { SupportIssueCategoryArticle } from './support-issue-category-articles.model';

export interface GenerateSupportIssueCategoryArticleOptions {
  readonly id?: number;
  readonly title?: string;
  readonly content?: string;
  readonly seoUrl?: string;
  readonly categoryIds?: readonly number[];
  readonly accountType?: string;
}

export function generateSupportIssueCategoryArticleObject({
  id = generateId(),
  title,
  content,
  seoUrl,
  categoryIds = [generateId()],
  accountType,
}: GenerateSupportIssueCategoryArticleOptions = {}): SupportIssueCategoryArticle {
  return {
    id,
    title: title ?? `Article ${id}`,
    content: content ?? `Content for article ${id}`,
    seoUrl: seoUrl ?? `article-${id}`,
    categoryIds,
    accountType,
  };
}

export function generateSupportIssueCategoryArticleObjects(
  articles: readonly GenerateSupportIssueCategoryArticleOptions[],
): readonly SupportIssueCategoryArticle[] {
  return articles.map(article =>
    generateSupportIssueCategoryArticleObject(article),
  );
}
